export const SEO_PROJECTION = `
  seo{
    metaTitle,
    metaDescription,
    seoKeywords,
    nofollowAttributes,
    openGraph{
      title, description, siteName, url,
      image{asset->{url, metadata{dimensions}}}
    },
    twitter{ site, creator, cardType },
    additionalMetaTags[]{
      metaAttributes[]{
        attributeKey, attributeType,
        attributeValueString,
        attributeValueImage{asset->{url}}
      }
    }
  },
  customSeo{
    metaTitle,
    metaDescription,
    seoKeywords,
    nofollowAttributes,
    metaImage{
      "url": coalesce(selectedUrl, url, datUrl, previewUrl, previewImg),
      "alt": textMetaproperties[name == 'Alt_text'][0].value,
      width,
      height
    },
    openGraph{
      title, description, siteName, url,
      image{
        "url": coalesce(selectedUrl, url, datUrl, previewUrl, previewImg),
        "alt": textMetaproperties[name == 'Alt_text'][0].value
      }
    },
    additionalMetaTags[]{
      metaAttributes[]{
        attributeKey, attributeType,
        attributeValueString,
        attributeValueImage{
          "url": coalesce(selectedUrl, url, datUrl, previewUrl, previewImg)
        }
      }
    }
  }
`;

export const pageBySlug = `
  *[slug.current == $slug && _type in $types][0]{
    "slug": slug.current,
    ${SEO_PROJECTION}
  }
`;

export const storeLocatorSEO = `
*[_type == "storeLocator"][0]{
  ${SEO_PROJECTION}
}
`;

export const homePageSEO = `
*[_type == "homePage" && _id == "homePage"][0]{
  ${SEO_PROJECTION}
}
`;

export const articlesListSEO = `
*[_type == "articlesList" && type == $type][0]{
  ${SEO_PROJECTION}
}
`;

export const faqsSEO = `
*[_type == "faqs"][0]{
  ${SEO_PROJECTION}
}
`;

export const contactUsSEO = `
*[_type == "contactUs"][0]{
  ${SEO_PROJECTION}
}
`;
